import { apiUrl } from '../config/api';

export const AUTH_EXPIRED_EVENT = 'veriplan:auth-expired';
const AUTH_EXPIRED_NOTICE_KEY = 'veriplan_auth_expired_notice';

function persistAuthExpiredNotice(message) {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.sessionStorage.setItem(AUTH_EXPIRED_NOTICE_KEY, message);
  } catch {
    // Ignore storage errors (private mode/quota).
  }
}

function clearAuthExpiredNotice() {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.sessionStorage.removeItem(AUTH_EXPIRED_NOTICE_KEY);
  } catch {
    // Ignore storage errors.
  }
}

export function consumeAuthExpiredNotice() {
  if (typeof window === 'undefined') {
    return '';
  }

  try {
    const notice = window.sessionStorage.getItem(AUTH_EXPIRED_NOTICE_KEY) || '';
    if (notice) {
      window.sessionStorage.removeItem(AUTH_EXPIRED_NOTICE_KEY);
    }
    return notice;
  } catch {
    return '';
  }
}

function notifyAuthExpired(message = 'Votre session a expire. Veuillez vous reconnecter.') {
  if (typeof window === 'undefined') {
    return;
  }

  persistAuthExpiredNotice(message);

  window.dispatchEvent(
    new CustomEvent(AUTH_EXPIRED_EVENT, {
      detail: { message },
    })
  );
}

export function getStoredToken() {
  return localStorage.getItem('veriplan_token');
}

export { clearAuthExpiredNotice };

export function buildRequestHeaders({ auth = false, json = false, headers = {} } = {}) {
  const mergedHeaders = { ...headers };

  if (json) {
    mergedHeaders['Content-Type'] = 'application/json';
  }

  if (auth) {
    const token = getStoredToken();
    if (!token) {
      notifyAuthExpired();
      throw new Error('Session expiree. Veuillez vous reconnecter.');
    }
    mergedHeaders.Authorization = `Bearer ${token}`;
  }

  return mergedHeaders;
}

export function resolveApiUrl(pathOrUrl) {
  if (/^https?:\/\//i.test(pathOrUrl)) {
    return pathOrUrl;
  }
  return apiUrl(pathOrUrl);
}

export async function apiFetch(pathOrUrl, options = {}) {
  const { auth = false, json = false, headers = {}, ...fetchOptions } = options;
  const finalUrl = resolveApiUrl(pathOrUrl);
  const requestHeaders = buildRequestHeaders({ auth, json, headers });

  const response = await fetch(finalUrl, {
    ...fetchOptions,
    headers: requestHeaders,
  });

  const hasAuthHeader = Boolean(requestHeaders.Authorization || requestHeaders.authorization);
  if (response.status === 401 && (auth || hasAuthHeader)) {
    notifyAuthExpired();
  }

  return response;
}
